<template>
  <div class="prahndsttls_types no-scroll-track">
    <ExpandCard
      v-for="box in types"
      :key="box.id"
      :opened="false"
      class="prahndsttls_box"
      :class="{ 'opacity_4 no-events': box.disabled }"
      :style="`
        --radius: 4px;
        --min-height: var(--min-title-height);
        --title-size: 1.5rem;
        --title-weight: 600;
        --title-color: var(--clr-white-0);
        --clr-back-title: var(--clr-black-1);
        --opener-size: 2rem;
        --title-padding: 0 1.5rem;
        --content-padding: 1.5rem 1.5rem;
        --opener-color:${box.disabled ? 'transparent' : 'var(--clr-grey-2)'}
      `"
    >
      <template #title>
        <div class="prahndsttls_title-wrapper">
          <div class="prahndsttls_title">
            {{ $t(`shortcut.${box.id}`) }}
          </div>
        </div>
        <PracticeStatsMainInfo
          :items="box.topBoxes"
          class="mr-auto"
          style="
            --size-title: 0.875rem;
            --display: flex;
            --gap: 0rem;
            --size-value: 1rem;
            --item-margin: 0 1rem 0 0;
          "
        />
      </template>
      <div class="f-column">
        <div class="prahndsttls_content">
          <PracticeStatMovesChart
            :items="box.moves"
            class="gw_box"
            style="--clr-box-back: var(--clr-black-2)"
          />
          <PracticeStatsSecondaryInfo :items="box.rows" />
        </div>
        <router-link
          :to="{ name: 'PracticeHands', query: { ffph_shortcut_type: box.id } }"
          class="mt-4 clr-white gw_btn-v1 text-medium ml-auto gw_btn_text"
        >
          <i class="mdi text-large mdi-cards-playing mr-2"></i>
          {{ $t('common.show_hands') }}
        </router-link>
      </div>
    </ExpandCard>
  </div>
</template>

<script>
import ExpandCard from '@/components/Common/ExpandCard/ExpandCard'
import format_mix from '@/mixins/format_mix'
import float_mix from '@/mixins/float_mix'
import PracticeStatsMainInfo from '@/components/PracticeHandsTotals/PracticeStatsMainInfo'
import PracticeStatsSecondaryInfo from '@/components/PracticeHandsTotals/PracticeStatsSecondaryInfo'
import PracticeStatMovesChart from '@/components/PracticeHandsTotals/PracticeStatMovesChart'

export default {
  name: 'PracticeHandsTotalsTypes',

  components: {
    PracticeStatsMainInfo,
    PracticeStatsSecondaryInfo,
    PracticeStatMovesChart,
    ExpandCard,
  },
  mixins: [format_mix, float_mix],
  props: {
    types: Array,
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.prahndsttls {
  &_types {
    overflow: auto;
    max-height: var(--vh-15);
    --min-title-height: 4.5rem;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    grid-gap: 1rem;
  }
  &_title-wrapper {
    display: flex;
    margin: 0.75rem 1rem auto 0;
    flex-wrap: wrap;
    min-width: 5rem;
  }
  &_content {
    display: flex;
    flex-direction: column;
    grid-gap: 1rem;
  }
}

@media (max-width: 1023px) {
  .prahndsttls {
    &_types {
      overflow: unset;
      max-height: unset;
      --min-title-height: 6rem;
    }
    &_content {
      grid-template-columns: 1fr;
      flex-wrap: wrap;
    }
  }
}
</style>
